/*
 * @Author: wlo_o
 * @Date: 2022-01-26 09:56:54
 * @LastEditors: wlo_o
 * @LastEditTime: 2022-02-23 11:31:35
 * @FilePath: /frontend/lib/common/options.js
 * @Description: 初始化配置文件
 *
 * Copyright (c) 2022 by 青岛百洋智能科技股份有限公司, All Rights Reserved.
 */
import Vue from 'vue'
import { fetchApi } from './apis.js'
import store from 'store2'
import get from 'lodash/get'
import { STORAGE_NAMESPACE } from './constant.js'
import { isEmpty } from 'lodash'

let serialize = require('serialize-javascript')

let options = {}
function resolveInitPromise () {
  if (!Vue.prototype.$OecpMetaDataEventBus.ready.init) {
    Vue.prototype.$OecpMetaDataEventBus.ready.resolve()
    Vue.prototype.$OecpMetaDataEventBus.ready.init = true
  }
}
// 初始化
export function initOptions () {
  if (!isEmpty(get(Vue.prototype, '$OecpMetaDataConfig.options'))) {
    return resolveInitPromise()
  }
  let cache = store.session(STORAGE_NAMESPACE + 'options')
  if (cache) {
    // eslint-disable-next-line no-eval
    let obj = eval('(' + cache + ')')
    options = { ...obj }
    Vue.prototype.$OecpMetaDataConfig = { ...Vue.prototype.$OecpMetaDataConfig, options }
    resolveInitPromise()
  } else {
    fetchApi.call(this, '/options/list', { autoload: '1' }).then(function (data) {
      options = data
      store.session(STORAGE_NAMESPACE + 'options', serialize(options))
      Vue.prototype.$OecpMetaDataConfig = { ...Vue.prototype.$OecpMetaDataConfig, options }
      resolveInitPromise()
    })
  }
}

export default options
